// extracted by mini-css-extract-plugin
export default {"header":"IR-z","isActive":"JR-z"};